import { z } from 'zod';

/** Ids de catálogo: estáveis, legíveis e seguros para usar em nome de arquivo e em log. */
export const IdSchema = z
  .string()
  .regex(/^[a-z0-9][a-z0-9_-]{0,63}$/, 'use de 1 a 64 caracteres: letras minúsculas, números, _ e -');

/** Ids de resultado gerados pelo serviço: r_ + ULID. */
export const ResultIdSchema = z.string().regex(/^r_[0-9A-HJKMNP-TV-Z]{26}$/, 'id de resultado inválido');

/** Ids de publicação do catálogo: p_ + ULID. */
export const PublicationIdSchema = z.string().regex(/^p_[0-9A-HJKMNP-TV-Z]{26}$/, 'id de publicação inválido');

export const TenantIdSchema = z.string().regex(/^[a-z0-9][a-z0-9-]{0,62}$/, 'tenant inválido');

/** Tenant único da edição Self-hosted. */
export const DEFAULT_TENANT = 'default';

/** Valor de célula como sai de qualquer fonte. */
export const CellSchema = z.union([z.string(), z.number(), z.null()]);
export type Cell = z.infer<typeof CellSchema>;

export const LocaleSchema = z.enum(['pt-BR', 'en', 'es']);
export type Locale = z.infer<typeof LocaleSchema>;
